import { requestCustomization } from 'actionCreators/customization';
import { savePageLoad } from 'actionCreators/healthcheck';
import LoginBanner from 'components/Course/LoginBanner';
import React, { Component } from 'react';
import { FABRICA_BASE_URL } from 'settings';
import { connect } from 'react-redux';
import { WithRouter } from 'decorators/withRouter';
import { ILesson } from 'interface/lesson';
import { fetchCourse } from 'actionCreators/course';
import { fetchLesson } from 'actionCreators/lessons';
import './styles.css';
import ThemeProvider from 'components/Shared/ThemeProvider/index';
import Hidden from '@material-ui/core/Hidden';
import BreadCrumb from 'components/Shared/BreadCrumb';
import { sendElastic } from 'actionCreators/judasLog';

interface IState {
  authenticated: boolean;
  openDialog: boolean;
  confirmDialog: boolean;
  lesson?: any;
}

interface IProps {
  embed: {
    loginUrl: string;
    testUrl: string;
    error?: string;
  };
  template: any;
  courseHash: string;
  error?: string;
  classes?: any;
  match?: any;
  lesson?: ILesson;
  fetchCourse?: any;
  fetchLesson?: Function;
  requestCustomization?: any;
  course?: any;
  isAuthenticated: boolean;
}

@WithRouter()
class FabricaDeProvasPage extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      authenticated: false,
      openDialog: false,
      confirmDialog: false,
    };
  }

  async componentDidMount() {
    const { lessonID } = this.props.match.params;
    const isAuthenticated = this.props.isAuthenticated;
    this.props.requestCustomization(this.props.match.params.courseHash);
    try {
      await this.props.fetchLesson(lessonID, this.props.course, isAuthenticated);
    } catch (error) {
      //TODO error
    }
    this.props.fetchCourse(this.props.match.params.courseHash);
  }

  setAuthenticated = () => {
    this.setState({ authenticated: true });
  };

  convertUrl = (url: string) => {
    if (FABRICA_BASE_URL) {
      return url.replace(/.fabricadeprovas.com.br/, '-' + FABRICA_BASE_URL);
    }
    return url;
  };

  render() {
    const { lesson, course, template } = this.props;
    const {
      params: { lessonContentId },
      url,
    } = this.props.match;

    const { authenticated } = this.state;

    if (!lesson.fetched) {
      return null;
    }
    // eslint-disable-next-line
    const embed: any = lesson.contents.filter((lc: any) => lc.id == lessonContentId)[0].embed;

    if (embed.error) {
      return (
        <LoginBanner
          isAuth={true}
          message={`Não conseguimos carregar o ambiente da prova. Erro: ${embed.error}`}
          route={`/curso/${course.hash}`}
          textButton='Volte para o curso'
        />
      );
    }

    if (course.hash && lesson.id) {
      sendElastic('viewTest', `Entrou na prova da aula ${lesson.title} do curso ${course.title}`, {
        courseHash: course.hash,
        courseId: course.id,
        lessonId: lesson.id,
      });
    }

    return (
      <ThemeProvider theme={template.course.theme}>
        <div className={`template-${course.theme}`}>
          <Hidden mdDown>
            <BreadCrumb
              pages={[
                {
                  icon: 'home',
                  name: 'Vitrine',
                  link: '/vitrine',
                },
                {
                  icon: 'video_library',
                  name: course.title,
                  link: `/curso/${course.hash}`,
                },
                {
                  icon: 'play_arrow',
                  name: lesson.title,
                  link: url.substring(0, url.length - lessonContentId.length),
                },
                {
                  icon: 'play_arrow',
                  name: 'Prova',
                  link: url,
                },
              ]}
            />
          </Hidden>
          <Hidden lgUp>
            <BreadCrumb
              pages={[
                {
                  icon: 'play_arrow',
                  name: lesson.title,
                  link: url.substring(0, url.length - lessonContentId.length),
                },
              ]}
            />
          </Hidden>
          <div className='fabrica-provas-iframe-div'>
            {!authenticated ? (
              <iframe
                title={'fabrica-provas'}
                className={'fabrica-provas-iframe'}
                src={this.convertUrl(embed.loginUrl)}
                onLoad={this.setAuthenticated}
                allowFullScreen
                scrolling='yes'
                allow='geolocation; microphone; camera'
              />
            ) : (
              <iframe
                title={'fabrica-provas'}
                className={'fabrica-provas-iframe'}
                src={this.convertUrl(embed.testUrl)}
                allowFullScreen
                scrolling='yes'
                allow='geolocation; microphone; camera'
              />
            )}
          </div>
        </div>
        ;
      </ThemeProvider>
    );
  }
}

const mapStateToProps = (state: any) => ({
  user: state.user,
  template: state.template,
  courseTheme: (state.customization.customizationData || {}).theme,
  course: state.course,
  lesson: state.lesson,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { requestCustomization, savePageLoad, fetchLesson, fetchCourse })(
  FabricaDeProvasPage
);
